var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.45756 10.1228L0.289989 11.9661C0.251304 12.3916 0.6078 12.7481 1.03333 12.7094L2.87661 12.5419L10.6176 4.80092L8.19851 2.38187L0.45756 10.1228ZM12.5528 2.86567C12.82 2.59847 12.82 2.16525 12.5528 1.89805L11.1014 0.446616C10.8342 0.179416 10.401 0.179416 10.1338 0.446616L8.68232 1.89806L11.1014 4.31711L12.5528 2.86567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenWhite);
export default __webpack_public_path__ + "static/media/pen-white.4e64d338c7045c4b7e059e44fd26391f.svg";
export { ForwardRef as ReactComponent };